import React, { useState } from 'react';
import './Logo.css';
import header from '../../../../_assets/img/header.png'
import header_min from '../../../../_assets/img/header_min.png'
import WelcomeModal from '../WelcomeModal';


const Logo = ({ onModalStateChange }) => {

  const clientWidth = document.documentElement.clientWidth;

  const [active, setActive] = useState(false);

    const handleClick = () => {
    setActive(true); // abre manualmente
  };

  const handleModalState = (isOpen) => {
    setActive(isOpen);               // controla o modal
    onModalStateChange?.(isOpen);    // avisa o Welcome.jsx
  };

  return (
    <>
      <img onClick={handleClick} className='LogoImage img-fluid' src={clientWidth > 600 ? header : header_min} alt={`Logo`}></img>
      <a onClick={handleClick} href='#' className='navbar-brand Logo'></a>
      <WelcomeModal callback={handleModalState} active={active}></WelcomeModal>

    </>
  );

}


export default Logo;
